import React, { useState, useEffect } from 'react'
import clsx from 'clsx'

const BlurText = ({
  text,
  delay = 150,
  startDelay = 0,
  animateBy = 'words', // 'words' or 'characters'
  direction = 'top', // 'top', 'bottom', 'left', 'right'
  onAnimationComplete,
  className = '',
}) => {
  const [visibleItems, setVisibleItems] = useState([])
  const items = animateBy === 'words' ? text.split(' ') : text.split('')

  useEffect(() => {
    // Reset visible items when text changes
    setVisibleItems([])

    const timers = []
    const itemsArray = animateBy === 'words' ? text.split(' ') : text.split('')

    itemsArray.forEach((_, index) => {
      const timer = setTimeout(
        () => {
          setVisibleItems((prev) => [...prev, index])
        },
        startDelay + delay * index
      )

      timers.push(timer)
    })

    // Call onAnimationComplete after all items are visible and animation is done
    // The last item starts at delay * (itemsArray.length - 1) and takes 500ms to complete
    if (onAnimationComplete) {
      const completionTimer = setTimeout(
        () => {
          onAnimationComplete()
        },
        startDelay + delay * (itemsArray.length - 1) + 500
      )

      timers.push(completionTimer)
    }

    return () => {
      timers.forEach((timer) => clearTimeout(timer))
    }
  }, [text, delay, startDelay, animateBy, onAnimationComplete])

  const getDirectionClass = () => {
    switch (direction) {
      case 'top':
        return 'translate-y-[-20px]'
      case 'bottom':
        return 'translate-y-[20px]'
      case 'left':
        return 'translate-x-[-20px]'
      case 'right':
        return 'translate-x-[20px]'
      default:
        return 'translate-y-[-20px]'
    }
  }

  return (
    <span className={clsx('inline-block', className)}>
      {items.map((item, index) => (
        <span
          key={index}
          className={clsx('inline-block transition-all duration-500', {
            'opacity-0 blur-[10px]': !visibleItems.includes(index),
            'opacity-100 blur-0': visibleItems.includes(index),
            [getDirectionClass()]: !visibleItems.includes(index),
            'translate-x-0 translate-y-0': visibleItems.includes(index),
          })}
          style={{
            transitionDelay: `${startDelay + index * delay}ms`,
          }}
        >
          {item}
          {animateBy === 'words' && index < items.length - 1 && '\u00A0'}
        </span>
      ))}
    </span>
  )
}

export default BlurText
